import makeStyles from "@material-ui/core/styles/makeStyles";

type Props = {
  hovering: boolean;
  backgroundFill: string;
};

const useStyles = makeStyles(() => ({
  icon: {
    cursor: "pointer",
    margin: 4,
  },
  viewText: {
    fontSize: 14,
    padding: 4,
    backgroundColor: ({ backgroundFill }: Props) => backgroundFill,
    display: ({ hovering }: Props) => (hovering ? "block" : "none"),
  },
}));

export default useStyles;
